/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ x: NonNullable<unknown>, y: NonNullable<unknown> }} Position_Modal_Preview_PositionInputs */



/**
* | output |
* | --- |
* | "Char: {x}, Line: {y}" |
*
* @param {Position_Modal_Preview_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_preview_position = /** @type {((inputs: Position_Modal_Preview_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Preview_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Car : ${i?.x}, Ligne : ${i?.y}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeichen: ${i?.x}, Zeile: ${i?.y}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Carattere: ${i?.x}, Riga: ${i?.y}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Символ: ${i?.x}, Строка: ${i?.y}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Carácter: ${i?.x}, Línea: ${i?.y}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`字符：${i?.x}，行：${i?.y}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`文字: ${i?.x}、行: ${i?.y}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अक्षर: ${i?.x}, पंक्ति: ${i?.y}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Caractere: ${i?.x}, Linha: ${i?.y}`)
	return /** @type {LocalizedString} */ (`Char: ${i?.x}, Line: ${i?.y}`)
});